import { Box, styled, Typography } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const Container = styled(Box)`
  background-color: #267ff8;
  left: 0;
  padding: 4px 8px 4px 8px;
  position: absolute;
  top: 0;
`

const Text = styled(Typography)`
  font-size: 10px;
  font-weight: 700;
`

const ApeironYouLabel: FC<Props> = props => {
  const { className } = props

  const { t } = useTranslation()

  return (
    <Container className={className}>
      <Text>{t('common.you')}</Text>
    </Container>
  )
}

type Props = {
  className?: string
}

export default ApeironYouLabel
